import * as actionTypes from "./actionTypes"


export function setLoading(visible,text) {
    return {
        type: actionTypes.SET_LOADING,
        payload: {visible:visible, text:text}
    }
}
